import { render, staticRenderFns } from "./wxList.vue?vue&type=template&id=2d3a22c1&"
import script from "./wxList.vue?vue&type=script&lang=js&"
export * from "./wxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports